export default __webpack_public_path__ + "static/media/staking_video.43c6fe9c.mp4";